import { OutlinedInputProps, OutlinedInput } from "@mui/material";
import { useState, useEffect } from "react";
type CustomSearchInputProps = {
  onChange: (value?: string) => void;
  value?: string;
} & Omit<OutlinedInputProps, "onChange" | "value">;
export const CustomSearchInput = ({ sx, value = "", onChange = () => {}, ...others }: CustomSearchInputProps) => {
  const [query, setQuery] = useState<string | undefined>("");

  useEffect(() => {
    setQuery(value);
  }, [value]);
  useEffect(() => {
    const timeOutId = setTimeout(() => {
      if (query !== value) {
        onChange(query);
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [query]);

  return (
    <OutlinedInput
      value={query}
      onChange={(e) => setQuery(e.target.value)}
      sx={[
        {
          backgroundColor: "primary.dark",
          borderRadius: "18px",
          border: "none",
          "& .MuiSvgIcon-root": {
            width: "20px",
            height: "20px",
            marginRight: "10px",
          },
          "& input": { paddingY: "14px" },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            border: "none",
          },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...others}
    />
  );
};
